module.exports = __webpack_public_path__ + "img/EIB.5b519304.png";